import { Pipe, PipeTransform } from '@angular/core';
import { SavedSearchInterface } from 'src/app/modals/intent-settings/models';

@Pipe({
    name: 'intentIncluded',
    standalone: false
})
export class IntentIncludedPipe implements PipeTransform {
  transform(selectedValue: number, savedSearches: SavedSearchInterface[]): boolean {
    return (savedSearches.find(saveSearch => saveSearch.id === selectedValue)?.intentsIncluded) || false;
  }
} 
